import styled from 'styled-components';
import { FlagOutlineIc, CreateIc } from '@dsch/dd-icons';
import { adWriteApi } from 'api/adWriteApi';
import { fireToast } from 'helpers/Toasts';
import { useAdDetailsContext } from 'contexts/AdDetailsContext';

import { GhostButton } from 'components/Toolkit/Button/GhostButton';
import { Link } from 'components/Toolkit/Button/Link';
import { formatAuthorizationHeader } from 'helpers/auth';
import { useAuthOptions } from 'hooks/useAuthOptions';

interface RevealReportAdProps {
  isViewingOwnAd?: boolean;
  editAdHREF?: string;
}

const SGhostButton = styled(GhostButton)`
  ${({ theme }) => theme.fontSize.M14};
`;

const SCreateIc = styled(CreateIc)`
  margin-right: ${({ theme }) => theme.spacing.S4};
  color: ${({ theme }) => theme.colors.GREY};
`;

const SLink = styled(Link)`
  color: ${({ theme }) => theme.colors.GREY_DARK};
  display: flex;
  align-items: center;

  &:hover {
    color: ${({ theme }) => theme.colors.BLUE_DARK};

    ${SCreateIc} {
      color: ${({ theme }) => theme.colors.BLUE_DARK};
    }
  }
`;

function RevealReportAd({
  isViewingOwnAd = false,
  editAdHREF,
}: RevealReportAdProps) {
  const { setIsReportAdModalOpen, setCategories, categories } =
    useAdDetailsContext();
  const { accessToken } = useAuthOptions();

  async function handleReveal() {
    try {
      if (!categories || categories.length === 0) {
        const { data } = await adWriteApi.getReportAdCategories(
          formatAuthorizationHeader(accessToken),
        );
        setCategories(data);
      }
      setIsReportAdModalOpen(true);
    } catch (_error) {
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later',
      });
      return false;
    }
  }

  return (
    <>
      {!isViewingOwnAd ? (
        <SGhostButton onClick={handleReveal}>
          <FlagOutlineIc height="18" width="18" />
          <span>Report this ad</span>
        </SGhostButton>
      ) : (
        <SLink ofType="SECONDARY" href={editAdHREF}>
          <SCreateIc height="18" width="18" />
          Manage my ad
        </SLink>
      )}
    </>
  );
}

export { RevealReportAd };
